<template>
  <div>
    <div class="card">
      <div class="d-flex space-between">
        <h3 class="card-title">Micrositios</h3>
        <router-link :to="{ name: 'CrearMicrositio' }" class="btn btn-primary">
          Nuevo micrositio
        </router-link>
      </div>
      <p v-if="loading" class="text-secondary">Cargando...</p>
      <template v-else-if="micrositios.length">
        <table class="table-list">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Orden</th>
              <th>Activo</th>
              <th>Noticias</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="micrositio in micrositios" :key="micrositio.id">
              <td><b>{{ micrositio.nombre }}</b></td>
              <td>{{ micrositio.descripcion }}</td>
              <td>{{ micrositio.orden }}</td>
              <td>{{ micrositio.activo ? 'Sí' : 'No' }}</td>
              <td>{{ micrositio.noticias_count }}</td>
              <td>
                <router-link
                  :to="{ name: 'EditarMicrositio', params: { id: micrositio.id } }"
                  class="btn btn-warning btn-sm"
                >
                  Editar
                </router-link>
                <button class="btn btn-error btn-sm" @click="eliminar(micrositio)">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <p v-else class="text-secondary">No hay micrositios creados.</p>
    </div>
  </div>
</template>
<script>
import { MicrositiosServices } from '../services/MicrositiosServices';
import Swal from 'sweetalert2';

export default {
  name: 'ListarMicrositios',
  data() {
    return {
      micrositios: [],
      loading: true,
    };
  },
  created() {
    this.cargar();
  },
  methods: {
    cargar() {
      this.loading = true;
      MicrositiosServices.api
        .getAll()
        .then((data) => {
          this.micrositios = data;
        })
        .catch(() => {
          Swal.fire('Error', 'No se pudieron cargar los micrositios', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    eliminar(micrositio) {
      Swal.fire({
        title: '¿Eliminar micrositio?',
        text: `Se eliminará "${micrositio.nombre}". Las noticias asociadas quedarán sin micrositio.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          MicrositiosServices.api
            .delete(micrositio.id)
            .then(() => {
              this.micrositios = this.micrositios.filter((m) => m.id !== micrositio.id);
              Swal.fire('Eliminado', 'El micrositio fue eliminado', 'success');
            })
            .catch(() => {
              Swal.fire('Error', 'No se pudo eliminar el micrositio', 'error');
            });
        }
      });
    },
  },
};
</script>
